import {LastCallRepositoriesFactory} from '../Repositories/factory.js'
import {CreateLastCallService} from './CreateLastCallService.js'

export class LastCallServicesFactory {
  static createLastCallService = ({config}) => {
    return new CreateLastCallService({
      config,
      repository: LastCallRepositoriesFactory.hTTPLastCallRepository({config})
    })
  }
}
